import { keys } from '@core/Services/Analytics/keys'
import { trackEvent } from '@core/Services/Analytics/track'

export const trackBetTypeChange = (data: object): void =>
  trackEvent(keys.productSelectionChanged, { data })
